import { connect } from 'react-redux';
import { actions, selectors } from 'app-webtech-core';
import { userAvatar as chatUserAvatarSelector } from 'app-modules/chat/selectors';
import { showAuthenticationDialog, hideAuthenticationDialog } from 'app-modules/ui/actions';
import { UserAccountComponent } from '../components/UserAccount';

const mapStateToProps = (state) => {
  const isAuthenticated = selectors.userAccount.isAuthenticated(state);
  const userAvatar = chatUserAvatarSelector(state);

  return {
    userAvatar,
    isAuthenticated,
    pairedDevices: selectors.pairedDevices.properties(state),
    isShowAuthenticationDialog: state.ui.showAuthenticationDialog,
    apiError: selectors.userAccount.properties(state).error,
  };
};

const mapDispatchToProps = {
  fetchAll: actions.pairedDevices.fetchAll,
  loginWithEmail: actions.userAccount.loginWithEmail,
  loginWithFacebookToken: actions.userAccount.loginWithFacebookToken,
  loginWithGoogleToken: actions.userAccount.loginWithGoogleToken,
  loginWithStoredToken: actions.userAccount.loginWithStoredToken,
  loginWithTwitterToken: actions.userAccount.loginWithTwitterToken,
  logout: actions.userAccount.logout,
  registerWithEmail: actions.userAccount.registerWithEmail,
  requestPasswordRecovery: actions.userAccount.requestPasswordRecovery,
  changePasswordStoredToken: actions.userAccount.changePasswordStoredToken,
  updateEmailStoredToken: actions.userAccount.updateEmailStoredToken,
  showAuthenticationDialog,
  hideAuthenticationDialog,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  loginWithStoredToken: async (data) => {
    const res = await dispatchProps.loginWithStoredToken(data);
    if (res && !res.error) {
      await dispatchProps.fetchAll();
    }
  },
});

export const UserAccount = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(UserAccountComponent);
